import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { ISongGroup } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface ISongGroupRecord extends Pick<ISongGroup, 'groupNumber' | 'groupTitle' | 'isActive' | '_id' | 'createdAt' | 'description'>{
    actions: unknown;
}

const CategoryList = () => {

    const { records, handleInteraction, deleteRecord, paginationState } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<ISongGroupRecord>[] =  [
        {
            Header: 'Бүлгийн дугаар',
            accessor: 'groupNumber',
        },
        {
            Header: 'Гарчиг',
            accessor: 'groupTitle'
        },
        {
            Header: 'Тайлбар',
            accessor: 'description'
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default CategoryList;